<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder mb-0">{{ $t('association.Logo_image') }}</h5>
    <p class="mb-0 text-sm">{{ $t('association.Optional_information') }} ({{ $t('association.Upload_logo_image') }})</p>
    <div class="multisteps-form__content mt-4">
      <div class="row">
        <div class="col-12">
          <!-- Dropzone Target -->
          <div id="associationLogo" class="form-control border dropzone"></div>
        </div>
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm js-btn-prev" type="button" @click="$parent.prevStep">
          {{ $t('common.Prev') }}
        </button>        
      </div>
    </div>
  </div>
</template>

<script>
import Dropzone from "dropzone";
import { ref, onMounted, defineExpose } from "vue";

export default {
  name: "LogoImageSection",
  props: {
    formData: Object,
    emitter: Object,
    nextStep: Function,
  },
  setup(props) {
    const dropzone = ref(null);
    const dropzoneElementId = "#associationLogo";

    const initializeDropzone = () => {    
      if (dropzone.value) return; // Prevent re-initialization

      Dropzone.autoDiscover = false;

      dropzone.value = new Dropzone(document.querySelector(dropzoneElementId), {      
        url: "https://httpbin.org/post", // Dummy URL
        maxFiles: 1,
        maxFilesize: 5, // in MB
        acceptedFiles: "image/*",
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictDefaultMessage: "Sleep bestanden hierheen om te uploaden",

        init: function () {
          this.on("addedfile", (file) => {
            console.log("File added:", file)
            if (props.emitter) {
              props.emitter.emit("logoImageUploaded", file)
            }
          })

          this.on("removedfile", () => {
            console.log("File removed")
            if (props.emitter) {
              props.emitter.emit("logoImageUploaded", null)
            }
          })
        }
      });
    };

    const processQueue = () => {
      dropzone.value?.processQueue();
    };

    const getQueuedFiles = () => {
      return dropzone.value?.getQueuedFiles() || [];
    };

    onMounted(() => {
      initializeDropzone();
    });

    // Expose methods to parent component
    defineExpose({
      processQueue,
      getQueuedFiles
    });

    return {      
    };
  },
};
</script>

<style scoped>
/* Optionally customize Dropzone */
.dropzone {
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}
</style>
